var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationaccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6693 8.80036C11.6693 7.327 10.4754 6.13315 9.00315 6.13315C7.52979 6.13315 6.33594 7.327 6.33594 8.80036C6.33594 10.2726 7.52979 11.4665 9.00315 11.4665C10.4754 11.4665 11.6693 10.2726 11.6693 8.80036Z",
    stroke: "#18173C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99948 20C7.7211 20 1 14.5583 1 8.86751C1 4.41241 4.58091 0.800003 8.99948 0.800003C13.4181 0.800003 17 4.41241 17 8.86751C17 14.5583 10.2779 20 8.99948 20Z",
    stroke: "#18173C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationaccount);
export default __webpack_public_path__ + "static/media/locationaccount.0aaee590e76c4bf7de36e0d2f4975369.svg";
export { ForwardRef as ReactComponent };